import { ArticleParagraph2, Checkbox } from '@cian/ui-kit';

import { RenderOption } from 'shared/components/Select/types';

import styles from './styles.css';

export const defaultOptionRenderer: RenderOption = props => {
  const { checked, label, description } = props;

  return (
    <>
      <Checkbox checked={checked} label={label} />
      {description && (
        <div className={styles['description']}>
          <ArticleParagraph2 color={'black_60'}>{description}</ArticleParagraph2>
        </div>
      )}
    </>
  );
};
